import service from '../utils/request'
// 保存
export const save = params => { return service.post(`/api/sys_device/save`, params) };
//根据Id获取会员信息
export const getdevsetbykey = params => { return service.get(`/api/sys_device/getdevsetbykey`, { params }) };
//获取系统参数列表
export const getsysparalist = params => { return service.get(`/api/sys_device/getsysparalist`, { params }) };
// 修改参数
export const editpara = params => {return service.put(`/api/sys_device/editpara`, params)};
//数据清除类型列表
export const datacleartypelist = params => { return service.get(`/api/sys_device/datacleartypelist`, { params }) };
//清除数据
export const cleandata = params => { return service.post(`/api/sys_device/cleandata`, params) };
// 保存地址
export const saveaddress = params => {return service.post(`/api/sys_device/saveaddress`, params)};
//获取门店经纬度
export const getlongitudeandlatitude = params => { return service.get(`/api/sys_device/getlongitudeandlatitude`, { params }) };

// 获取授权日志
export const getauthlogmv = params => { return service.post(`/api/sys_device/getauthlogmv`, params) };


// 获取授权日志
export const query = params => { return service.post(`/api/sys_device/query`, params) };

//获取系统参数列表
export const getsmsbalance = params => { return service.get(`/api/sys_device/getsmsbalance`, { params }) };
